<template>
    <div class="product__block">
        <div class="basket__open" @click="productId(id)">
            <div v-if="remain <= 0" class="remain_null">
                <p>
                    Нет в продаже
                </p>
            </div>
            <div class="product__block__img">
                <img
                    v-if="img"
                    :src="'https://ecodom04.com/backend/'+img"
                    alt="images"
                >
                <img
                    v-if="!img"
                    src="../assets/not_found.png"
                    alt="images"
                >
            </div>
            <div class="product__block__title" id="product__block__title_scroll">
                <p>
                    {{title}}  
                </p>
            </div>
        </div>
        <div class="product__block___btn__and__price">
            <div class="product__block___btn__and__price__l">
                <div v-if="stock_price != null">
                    <p>
                        <span>{{stock_price}}</span> ₸
                    </p>
                    <p class="stock_price_color">
                        <strike>{{price}}</strike> ₸
                    </p>
                </div>
                <p v-else>
                    <span>{{price | numeral('0,0')}}</span> ₸
                </p>
            </div>
            <div class="product__block___btn__and__price__r">
                <button title="Добавить в избранное" @click="addToFavorite" class="product__block___btn__and__price__r_favotite">
                    <span class="mdi mdi-cards-heart"></span>
                </button>
                <button v-if="remain <= 0" title="Предзаказ" class="remain_btn" @click="addToCart">
                    Предзаказ
                </button>
                <button v-if="remain > 0" title="Добавить в корзину" @click="addToCart">
                    <span class="mdi mdi-basket"></span>
                </button>
            </div>
        </div>
    </div>
</template>


<script>

export default {
  name: 'ProductBlock',
  props: {
    id: Number,
    img: String,
    title: String,
    price: Number,
    stock_price: Number,
    description: String,
    remain: Number,
  },
  data() {
    return {
      price_replace: this.price,
    };
  },
  methods: {
    productId(id) {
        this.$router.push({ name: 'ProductPage', params: { id: id }})
    },
    addToFavorite() {
        this.$emit('addToFavorite',{
            id: this.id,
            img: this.img,
            title: this.title,
            price: this.price,
            quantity: 1,
            oldprice: this.price,
            description: this.description,
            remain: this.remain,
        })
        this.$toasted.show('Добавлен в избранное').goAway(1500)
    },
    addToCart() {
        this.$emit('addToCart',{
            id: this.id,
            img: this.img,
            title: this.title,
            price: this.price,
            quantity: 1,
            oldprice: this.price,
            description: this.description,
            remain: this.remain,
        })
        this.$toasted.show('Добавлен в корзину').goAway(1500)
    }
  }
}
</script>

<style scoped lang="less">
@baseMedia: 900px;

.product__block {
    width: 92%;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    padding-bottom: 20px;
    align-items: center;
    flex-direction: column;
    margin: 0 auto;
    &:hover {
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    }
    .basket__open {
        width: 90%;
        position: relative;
        .remain_null {
            padding: 5px 10px;
            color: #fff;
            font-weight: bold;
            background: red;
            position: absolute;
            top: 0;
            box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.5);
            right: 0;
            @media (max-width: @baseMedia) {
                padding: 2px 5px;
                font-size: 12px;
            }
        }
        .product__block__img {
            width: 100%;
            height: 150px;
            background: #fff;
            border: 1px solid #ccc;
            border-radius: 5px;
            margin-top: 10px;
            overflow: hidden;
            text-align: center;
            img {
                height: 100%;
                &:hover {
                    transition: .7s;
                    height: 110%;
                }
            }
        }
        #product__block__title_scroll::-webkit-scrollbar-track
        {
            background-color: transparent;
        }

        #product__block__title_scroll::-webkit-scrollbar
        {
            width: 1px;
        }

        #product__block__title_scroll::-webkit-scrollbar-thumb
        {
            background-color: #ccc;
        }
        .product__block__title {
            width: 100%;
            text-align: center;
            margin-top: 10px;
            height: 61px;
            @media (max-width: @baseMedia) {
                font-size: 14px;
                height: 51px;
            }
            overflow-y: scroll;
        }
    }
    
    .product__block___btn__and__price {
        width: 90%;
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        align-items: center;
        .product__block___btn__and__price__l {
            width: 37%;
            text-align: left;
            .stock_price_color {
                color: #a71630;
            }
            p {
                font-size: 20px;
                color: #690;
                span {
                    font-weight: bold;
                }
            }
        }
        .product__block___btn__and__price__r {
            width: 63%;
            text-align: right;
            .product__block___btn__and__price__r_favotite {
                background: #a71630;
                padding: 8px 10px;
                border-radius: 5px;
                margin-right: 5px;
                @media (max-width: @baseMedia) {
                    padding: 5px 6px;
                    border-radius: 5px;
                    font-size: 12px;
                }
            }
            .remain_btn {
                background: #eefd00;
                font-weight: bold;
            }
            button {
                background: #0a9;
                padding: 8px 10px;
                border-radius: 5px;
                @media (max-width: @baseMedia) {
                    padding: 5px 6px;
                    border-radius: 5px;
                    font-size: 12px;
                }
                span {
                    color: #fff;
                }
                &:hover {
                    opacity: 0.7;
                }
            }
        }
    }
}
 
</style>
